<!-- 员工敏感词 -->
<template>
  <div>
    <!-- 表格 -->
    <el-row :gutter="20">
      <el-col>
        <el-table
        v-loading="loading"
          size="small"
          :data="tableData"
          fit
          @row-click="handleclick"
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(60vh - 2px)"
          ref="cusChatTable"
          style="font-size: 13px"
        >
          <el-table-column
            prop="externalName"
            label="客户信息"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="wordName"
            label="敏感词"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="触发时间"
            min-width="150"
          ></el-table-column>
          <el-table-column label="聊天记录" min-width="200">
            <template slot-scope="scope">
              <div class="content-record" style="color: #1F74E1">{{scope.row.content}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      :childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- 聊天记录弹窗dialogVisible   -->
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        class="chat-content-dialog"
        append-to-body
        width="600px"
        center
        @open="open"
        ref="dia"
      >
      <div class="content-container">
        <SenWordChatCommon ref="SenWordChatCommon" />
      </div>
    </el-dialog> 
  </div>
</template>

<script>
import SenWordChatCommon from "./SenWordChatCommon.vue"
import {oneUser} from "@/api/senWord/senWord.js"
export default {
  name: 'StaffSen',
  components: {
    SenWordChatCommon
  },
  props: ['uid'],
  data() {
    return {
      // 聊天记录的参数
      contentParam: {
        sendFrom: '',     // 员工userId
        sendTo: '',       // 企微客户Id
        msgId: ''         // 触发敏感词的信息Id
      },
      dialogVisible: false,
      tableData: [],
      params: {
        userId: this.uid,
        startTime: '',
        endTime: '',
        current: 1,
        size: 10
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      pageSizes: [10, 50, 100, 200, 500], //分页条数
      loading: false
    }
  },
  created() {
    this.params.current = this.pageparm.currentPage;
    this.params.size = this.pageparm.pageSize;
  },
  methods: {
    open(){
      console.log('aaa')
      console.log(this.$refs.dia)
    },
    // 获取数据
    getData(params) {
      let that = this;
      this.loading = true
      oneUser(params,localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200){
          that.pageparm.total = res.data.total;
          that.tableData =  res.data.result;
        }
      }).catch(err => {
        console.log(err,'errr')
      }).finally(()=>{
        this.loading =false
      })
    },
    // 初始化调用方法（给父组件调用）
    init(uid,startTime, endTime) {
      this.params.userId = uid;
      this.params.startTime = startTime;
      this.params.endTime = endTime;
      this.params.current = 1;
      this.getData(this.params);
    },
     // 分页回调函数
    callBack(parm) {
      this.params.current = parm.currentPage;
      this.params.size = parm.pageSize;
      this.getData(this.params);
    },
    // 表格单击事件
    handleclick(row, column, event) {
      let obj = {
        sendFrom: row.userId,     // 员工userId
        sendTo: row.externalUserid,       // 企微客户Id
        msgId: row.msgId         // 触发敏感词的信息Id
      }
      this.dialogVisible = true;
      this.$nextTick(()=>{
        console.log(row.msgId)
        this.$refs.SenWordChatCommon.getData(obj,row.wordName)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.chat-content-dialog {
  // min-width: 500px;
  /deep/.content-container {
    height: 100%;
    overflow-y: scroll;
  } 
  /deep/ .el-dialog__header {
    padding: 0;
    top: 12px;
  }
  /deep/.el-dialog__body {
    height: 486px;
    padding: 0px;
  }
  /deep/.el-dialog__footer {
    padding: 0;
  }
}
.content-record {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
/deep/.page-box {
  margin: 5px;
}
</style>